import { ExclamationTriangleIcon } from "@radix-ui/react-icons"
import { Flex, Heading } from "@radix-ui/themes"
import React from "react"
export default function WithdrawalRub() {
    return (
       <Flex align={'center'} justify={'center'} height={'90vh'} direction={'column-reverse'}>
      <Heading>Раздел в разработке</Heading>
      <ExclamationTriangleIcon width={'300px'} height={'300px'} />
       </Flex>
    )
}